import React from 'react';
import LinkCard from '../shared-components/link_card';
import "./GameViews/gameViewMedia.css";
import "./GameViews/gameViews.css";
import { connect } from 'react-redux';
import { setInfo } from '../../redux/actionList';

import SetupFunStuffModal from './setup_fun_stuff_modal';
import SetupCreditCardModal from './setup_credit_card_modal';
import CreditCardStatementModal from './credit_card_statement_modal';
import SetupTimeWizardModal from './setup_time_wizard_modal';
import InformationModal from '../shared-components/information_modal';
import UnlockedFeaturesCriteriaModal from './unlocked_features_criteria_modal';
import { calcMonthlyIncome } from '../../objects/CommonUse/calcMonthlyIncome';
import calculateShortTermSavings from './objectsHome/calculate_short_term_savings';
import { calculateJobSalary } from '../../objects/AssetsExpenses/calculate_job_salary';
import determineCreditScore from './objectsEndOfTurn/determine_credit_score';
import checkIfCreditCardEligible from './objects/check_if_credit_card_eligible';
import creditCardParameters from './datasets/credit_card_parameters';
import determineNbrUnlockedLevels from './objectsEndOfTurn/determine_nbr_unlocked_levels';

// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameData: state.gameData,
    savingsInfo: state.savingsInfo,
    creditCardInfo: state.creditCardInfo,
    timeWizardInfo: state.timeWizardInfo,
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};


class UnlockedFeatures extends React.Component {
    constructor(props) {
        super(props);
        this.gameData = JSON.parse(JSON.stringify(this.props.gameData));
        this.savingsInfo = JSON.parse(JSON.stringify(this.props.savingsInfo));
        this.creditCardInfo = JSON.parse(JSON.stringify(this.props.creditCardInfo));
        this.timeWizardInfo = JSON.parse(JSON.stringify(this.props.timeWizardInfo));
        this.state = {
            openInformationModal: false,
            savingsOpen: false,
            nextProcess: ""
        }  
        this.openProcess = false;
        this.savingsOpen = false;
        this.maxMonths = this.props.totalNbrGameMonths;
        this.questionMarkImg = "./assets/Icons/gameHelp.png";
       
    }

calcCreditScore(){
    this.creditReport = determineCreditScore(this.creditCardInfo, 
        this.gameData.loanTable, this.gameData.currentGameDate,
        this.gameData.gameNbrMonths, this.props.timeWizardInfo );
    this.props.setInfoRedux(this.creditReport, "creditReport");
}

calculateCurrentCash(){
    this.currentCash = +this.gameData.currentCash;
    this.savings = false;
    if (this.savingsInfo.gameID ){
        const shortTermSavings = calculateShortTermSavings(this.savingsInfo);
        this.currentCash += +shortTermSavings;
        this.savings = true;
    }
}

checkProcessSelected(){
    this.setDisabledStatus();
    switch (this.props.selected){
        case "setupFunStuff":
            this.setupFunStuffOptions();
            break;
        case "setupCreditCard":
            this.displayCreditCardInfo();
            break;
        case "moneyBuilder":
            this.setupMoneyBuilder();
            break;
        case "setupTimeWizard":
            this.setupTimeWizardOptions();
            break;
        default:
            break;
    }
    
}

setDisabledStatus(){
    this.creditCardOK = false;
    this.timeWizard = false;
    this.moneyBuilderOK = false;
    for (let i=0; i<this.gameData.unlockedFeatures.length; i++){
          let feature = this.gameData.unlockedFeatures[i];
          switch (feature.featureName) {
                case "funStuff":
                    this.funStuffOK = true;
                    break;
                case "creditCard":
                    this.creditCardOK = true;
                    break;
                case "timeWizard":
                    this.timeWizardOK = true;
                    break;
                case "moneyBuilder":
                    this.moneyBuilderOK = true;
                    break;
                default:
                    break;
          }
    }
}

setupFunStuffOptions() {
    if (this.funStuffOK === true) {
        this.openProcess = true;
        this.setState({nextProcess: "funStuff"});
    }
}

displayCreditCardInfo(){
    this.openProcess = true;
    let feature = this.gameData.unlockedFeatures.find(elem=> elem.featureName === "creditCard");
    const cardIndx = +feature.level - 1;
    const creditMaxAmt = creditCardParameters[cardIndx].maxCreditCardAmt;
    const annualSalary = calculateJobSalary(this.gameData.assetTable, 
        this.gameData.currentGameDate, false, "annual");
    const eligibleCheck = checkIfCreditCardEligible(annualSalary, creditMaxAmt, this.creditReport);
    this.creditCardEligible = eligibleCheck.creditCardAuthorization;
    // when unlocked feature is set to 'none', it means a new level has been authorized
    // if only the creditCardUtilization is false, then player can make a payment and 
    // 'fix' their credit score
    if (this.creditCardEligible === true &&
       (feature.setup === "none" || !this.creditCardInfo.gameID)){
        // check to see if still eligible for new level
        if (+feature.level > 1 && this.creditCardInfo.gameID ){ 
            this.changeCreditCardPolicy("newLevel");
        }else{
            this.changeCreditCardPolicy("policy");
        }
    }else{
        this.creditCardPaymentRequired = false;
        if (feature.setup === "none" &&
            this.creditCardInfo.totalOutstandingBalance > 0){
            this.creditCardPaymentRequired = true;
            this.changeType = "payment";
        }
        this.setState({nextProcess: "creditCardStatement"});
    }
}

setupTimeWizardOptions(){
    this.openProcess = true;
    let feature = this.gameData.unlockedFeatures.find(elem=> elem.featureName === "timeWizard");
    // when unlocked feature is set to 'none', it means a new lvel has been authorized
    if (!feature){
        this.timeWizardLevel = 1;
    }else{
        this.timeWizardLevel = feature.level;
    }
    if (!this.timeWizardInfo.gameID ||
            this.timeWizardInfo.status === "inactive"){
            this.nbrMonthsPerTurn = 1;
            this.nbrGameYears = 30;
    }else{
            this.nbrMonthsPerTurn = this.timeWizardInfo.monthsPerTurn;
            this.nbrGameYears = this.timeWizardInfo.gameNbrYears; 
    }
    this.setState({nextProcess: "timeWizard"});
    
}

changeCreditCardPolicy(changeType){
    this.openProcess = true;
    this.changeType = changeType;
    this.setState({nextProcess: "creditCardSetup"});
}

setupMoneyBuilder() {
    this.props.setInfoRedux ("unlocked-features", "prevProcess");
    this.openProcess = true;
    this.props.onNavigate("conductor-dashboard");
}

displayFeatureCriteria(featureName){
    this.openProcess = true;
    this.featureName = featureName;
    let feature = this.gameData.unlockedFeatures.find(elem => elem.featureName === this.featureName);
    if (!feature){
          this.featureLevel = 0;
          this.featureStatus = "none";
    }else{
        const maxLevelArr = determineNbrUnlockedLevels(featureName);
        const maxLevel = maxLevelArr[0].nbrLevels;
        if (feature.setup === "inactive" && +feature.level < +maxLevel){
            this.featureLevel = +feature.level + 1;
            this.featureStatus = "none";
        }else{
            this.featureLevel = feature.level;
            this.featureStatus = feature.setup;
        }
    }
    this.nbrGameMonths = +this.maxMonths - +this.gameData.gameNbrMonths;
    let incomeObj = calcMonthlyIncome(this.gameData.assetTable,
        this.gameData.expenseTable, this.gameData.loanTable);
    this.monthlyIncome = incomeObj.income;
    this.annualSalary = 0;
    this.creditScoreObj = {};
    if (featureName === "creditCard"){
        this.annualSalary = calculateJobSalary(this.gameData.assetTable, 
            this.gameData.currentGameDate, false, "annual");
    }
    this.setState({nextProcess: "featureCriteria"});
}

displayClassSettings(){
   
    this.className = "col-sm-8 mt-1";
    //  this needs to be different than the value set by the standard 
    this.colClass = "game-column-width";
    this.btnClass = "fancy-button img-overlay-unlocked";
}

  render() {
        if (this.state.nextProcess !== ""){
            sessionStorage.setItem("GameViewSubProcess", this.state.nextProcess);
        }

  return <>
    <div className={this.className}>
        <div className="card mt-3 mx-2 rounded-corners-lg text-center game-board height-max">
            <h3 className="mt-2 text-center">Unlocked Features</h3>
            <span className="row w-100 mx-0 ml-2">
                <span className="col-sm-5 mt-0 ml-5">
                    <button type="button" className={this.btnClass} size="sm" 
                        onClick={() => this.displayFeatureCriteria("moneyBuilder")}>
                            Check
                    </button>
                    {this.moneyBuilderOK ?
                        <div className="text-pointer" onClick={() => this.setupMoneyBuilder()}>
                            <LinkCard name="Money Builder" 
                                imgSrc='./assets/UnlockedFeatures/moneyBuilder.jpg' alt=""/>
                        </div>
                    :
                        <div className="buttonDisabledImage">
                           <LinkCard name="Money Builder" 
                                imgSrc='./assets/UnlockedFeatures/moneyBuilder.jpg' alt=""/>
                        </div>
                    }
                </span>
               
                <span className="col-sm-5 mt-0">
                    <button type="button" className={this.btnClass} size="sm" 
                            onClick={() => this.displayFeatureCriteria("funStuff")}>
                                    Check
                    </button>
                    {this.funStuffOK ?
                        <div className="text-pointer"   
                            onClick={() => this.setupFunStuffOptions()}>
                            <LinkCard name="Fun Stuff" imgSrc='./assets/UnlockedFeatures/funStuff.jpg'
                                 alt="funStuff"  />
                        </div>
                    :
                        <div  className="buttonDisabledImage"  > 
                            <LinkCard name="Fun Stuff" imgSrc='./assets/UnlockedFeatures/funStuff.jpg'
                                 alt="funStuff"  />
                        </div>
                    }
                      
                </span>
             
            </span>
            <span className="row w-100 ml-2">
                <span className="col-sm-5 mt-4 ml-5">
                        <button type="button" className={this.btnClass} size="sm" 
                            onClick={() => this.displayFeatureCriteria("creditCard")}>
                                Check
                        </button>
                    {this.creditCardOK ?
                        <span>
                            <div className="text-pointer"
                                onClick={() => this.displayCreditCardInfo()}>
                                <LinkCard name="Setup Credit Card" 
                                    imgSrc='./assets/UnlockedFeatures/creditCard.png' alt=""/>
                            </div>
                        </span>
                    :
                        <div className="buttonDisabledImage pt-0"
                            onClick={() => this.displayFeatureCriteria("creditCard")}>
                            <LinkCard name="Setup Credit Card" 
                                imgSrc='./assets/UnlockedFeatures/creditCard.png'  alt=""/>
                        </div>
                    } 
               
                </span>
                <span className="col-sm-5 mt-4 ">
                    <button type="button" className={this.btnClass} size="sm" 
                        onClick={() => this.displayFeatureCriteria("timeWizard")}>
                            Check
                    </button>
                    {this.timeWizardOK ?
                        <div className="text-pointer" onClick={() => this.setupTimeWizardOptions()}>
                            <LinkCard name="Time Wizard" 
                                imgSrc='./assets/UnlockedFeatures/timeWizard.png' alt=""/>
                        </div>
                    :
                        <div className="buttonDisabledImage">
                            <LinkCard name="Time Wizard" 
                                imgSrc='./assets/UnlockedFeatures/timeWizard.png' alt=""/>
                        </div>
                    }
                   
                </span>
            </span>
            
            {this.state.nextProcess === "funStuff" ?
                <SetupFunStuffModal show={this.openProcess}
                    gameInfo = {() => this.props.gameInfo()}
                    checkUnlockedFeatures={() => this.props.checkUnlockedFeatures()}
                    onClose={(returnVal) => this.closeModal(returnVal)}
                    setGameInfo = {(value, propertyName, subPropertyName) => 
                        this.props.setGameInfo(value, propertyName, subPropertyName)}
                    processError = {(errorObj) => this.props.processError(errorObj)}
                />
            :
                null
            }
            
            {this.state.nextProcess === "creditCardSetup" ?
                <SetupCreditCardModal show={this.openProcess}
                    changeType= {this.changeType}
                    eligible={this.creditCardEligible}
                    checkUnlockedFeatures={() => this.props.checkUnlockedFeatures()}
                    onClose={(returnVal, creditReport) => this.closeModal(returnVal, creditReport)}
                    gameInfo = {() => this.props.gameInfo()}
                    setGameInfo = {(value, propertyName, subPropertyName) => 
                        this.props.setGameInfo(value, propertyName, subPropertyName)}
                    processError = {(errorObj) => this.props.processError(errorObj)}
               />
            :
                null
            }
            
            {this.state.nextProcess === "creditCardStatement" ?
                <CreditCardStatementModal show={this.openProcess}
                    creditCardText={this.creditCardText}
                    creditCardPaymentRequired={this.creditCardPaymentRequired}
                    onClose={(returnVal) => this.closeModal(returnVal)}
                    gameInfo = {() => this.props.gameInfo()}
                    onChangePolicy={(changeType) => this.changeCreditCardPolicy(changeType)}
                    setGameInfo = {(value, propertyName, subPropertyName) => 
                        this.props.setGameInfo(value, propertyName, subPropertyName)}
                    processError = {(errorObj) => this.props.processError(errorObj)}
                />
            :
                null
            }
             
            {this.state.nextProcess === "timeWizard" ?
                <SetupTimeWizardModal show={this.openProcess}
                    onClose={(returnVal) => this.closeModal(returnVal)}
                    gameInfo = {() => this.props.gameInfo()}
                    nbrMonthsPerTurn={this.nbrMonthsPerTurn}
                    nbrGameYears={this.nbrGameYears}
                    level={this.timeWizardLevel}
                    resetTotalNbrGameMonths=
                        {(totalNbrGameMonths) => this.props.resetTotalNbrGameMonths(totalNbrGameMonths)}
                    setGameInfo = {(value, propertyName, subPropertyName) => 
                        this.props.setGameInfo(value, propertyName, subPropertyName)}
                    processError = {(errorObj) => this.props.processError(errorObj)}
                />
            :
                null
            }

            {this.state.nextProcess === "featureCriteria"  ?
                <UnlockedFeaturesCriteriaModal show={this.openProcess}
                    featureName={this.featureName}
                    featureLevel={this.featureLevel}
                    featureStatus={this.featureStatus}
                    gameNbrMonths={this.nbrGameMonths}
                    currentCash={this.currentCash}
                    savings={this.savings}
                    monthlyIncome={this.monthlyIncome}
                    annualSalary={this.annualSalary}
                    creditReportObj={this.creditReport}
                    onClose={() => this.closeModal("featureCriteria")}
                />
            :
                null
            }

            {this.state.openInformationModal   ?
                <InformationModal   
                    time={3000}
                    show={this.state.openInformationModal}
                    infoCode={this.informationCode}
                    onClose={() => this.closeInformationModal()}
                />
            :
                null
            }
                       
        </div>
    {/*
        {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
    */}
    </div>   
</>
  }

componentDidMount(){
    this._isMounted = true; 
    this.props.onOpen();
    this.displayClassSettings();
    this.calcCreditScore();
    this.calculateCurrentCash();
    this.checkProcessSelected();  
}

closeModal(returnVal, creditReport) {
    this.openProcess = false;
    this.setDisabledStatus();
    if (returnVal === "featureCriteria" || returnVal === "payment"){
        //  nothing further required
    }else{
        if (returnVal === "openFeatureCriteria"){
            this.displayFeatureCriteria("creditCard");
        }else{
            const buttonType = sessionStorage.getItem("funStuffButtonClicked");
            if (buttonType !== "decline" && returnVal !== "none" && returnVal !== "back"){
                this.informationCode = "UnlockedFeature";
                this.openInformationDisplayModal();
            }
        }
    }
    if (creditReport){
        this.creditReport = creditReport;
    }
    this.setState({nextProcess: ""});
}

openInformationDisplayModal(){
    this.setState({openInformationModal: true});
}

closeInformationModal(){
    this.props.onNavigate("game-board");
}

}

export default connect(mapStateToProps, mapDispatchToProps)(UnlockedFeatures);